import React, { useEffect, useState } from "react";
import SisLoader from "../../../../widgets/loader";
import { post } from "../../../../services/services";
import { ApiURL } from "../../../../services/apiConstants";
import PumpDetailsTable from "../components/PumpRow";

function StaffPumps({ id }) {
  const [loader, setLoader] = useState(false);
  const [filteredData, setFilteredData] = useState([]);

  const fetchPumpList = async () => {
    setLoader(true);
    const formData = new FormData();
    formData.append("ship_id", id);

    try {
      const res = await post(ApiURL.list_ship_pump_details_st, formData);
      if (res?.status === true) {
        setFilteredData(res?.response_data || []);
      }
    } catch (error) {
      console.error("Error fetching pump list:", error);
    } finally {
      setLoader(false);
    }
  };

  useEffect(() => {
    fetchPumpList();
  }, []);

  return (
    <>
      <h3 style={{ margin: "15px 0", fontWeight: "600" }}>Pump Information</h3>
      {loader ? (
        <SisLoader />
      ) : filteredData.length > 0 ? (
        <PumpDetailsTable data={filteredData} />
      ) : (
        <p>No data available</p>
      )}
    </>
  );
}

export default StaffPumps;
